module.exports = __webpack_public_path__ + "media/images/drag_and_drop_hexagon_outline-73f9e6d4986d9c6d6c7905c6d7c3b2dd.svg";